import React from 'react';
import MyApp from './MyApp.tsx';
import ReactDOM from 'react-dom/client';

ReactDOM.createRoot(document.getElementById('root')!).render(
	<React.StrictMode>
		<MyApp />
	</React.StrictMode>
);
